import p from 'x/config/platform-specific'

const XGalleryModal = p.comp.getXGalleryModal()

export default XGalleryModal
